module.exports = __webpack_public_path__ + "assets/img/img272.600e7a67.png";